const bg = {
    actionAlready: "Още не сте се регистрирали? Влезте",
    actionExit: "Изход",
    actionLogin: "ВЛЕЗТЕ",
    actionRegister: "РЕГИСТРИРАЙТЕ СЕ",
    actionSave: "ЗАПАЗЕТЕ",
    actionStart: "НАЧАЛО",
    actionContinue: "ПРОДЪЛЖЕТЕ",
    actionReset: "НУЛИРАНЕ НА ОЦЕНКАТА",
    actionDoDiagnost: "ПОКАЖЕТЕ ДИАГНОЗАТИКАТА",
    actionYes: "Да",
    actionNo: "Не",
    actionNext: "НАПРЕД",
    actionBusinessCase: "ПОКАЖЕТЕ ДОБРИ ПРАКТИКИ НА КОМПАНИЯТА",
    actionBusinessCases: "ПОКАЖЕТЕ ДОБРИ ПРАКТИКИ НА КОМПАНИИТЕ",
    actionOpenUrl: "ОТВОРЕТЕ URL",
    actionFilter: "ФИЛТРИРАЙТЕ",

    /** HOME */
    msgHomeTitleOne: "Измерете и увеличете нивото на кръговата зрялост на вашата мебелна компания",
    msgHomeSubTitle: "Онлайн инструментът FurnCIRCLE оценява напредъка на вашата компания към кръговата зрялост въз основа на приложените стратегии за кръгов дизайн",

    msgHomeSection2: "Оценете и подобрете зрелостта на кръговата икономика на вашата мебелна компания",
    msgHomeSection2Text: "<span style='font-weight:bold;'>Инструмент за оценка на кръговата икономика FurnCIRCLE</span><br/><br/>FurnCIRCLE е онлайн инструмент за самооценка, който помага на производителите на мебели да оценят своята зрелост в кръговата икономика и да идентифицират възможности за подобрение.<br/><br/><span style='font-weight:bold;'>Готови ли сте да оцените своята кръгова зрялост?</span><ul style='padding-left: 20px'><li>Отговорете на въпроси за стратегиите за кръгов дизайн, внедрени във вашата компания.</li><li>Открийте нивото си на зрелост в кръговата икономика.</li><li>Идентифицирайте стратегии и добри практики, които да помогнат на компанията ви да премине на следващото ниво.</li><li>Учете от реални примери от индустрията и продължете да подобрявате вашето кръгово представяне.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Допринесете за европейската оценка на кръговостта в мебелния сектор | Проект R-evolve</span><br/><br/>FurnCIRCLE в момента се използва в <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>проекта R-evolve</a> за оценка на зрелостта на кръговата икономика в европейския мебелен сектор. <span style='font-weight:bold;'>Над 400 компании от цяла Европа</span> са поканени да участват и да помогнат за картографиране на текущото ниво на кръговост в индустрията.<br/><br/>Включете се в оценяването, оценете вашата компания и допринесете за оформянето на бъдещето на сектора.<br/><br/>Всички данни се третират поверително и се използват само в агрегирана форма за целите на бенчмаркинг и изследвания. <span style='font-weight:bold;'>Участниците ще получат достъп до агрегирани резултати от бенчмаркинг</span>, което им позволява да сравняват представянето си със секторните средни стойности въз основа на анонимизирани и агрегирани данни от участващи компании в европейския мебелен сектор.<br/><br/>Попълването на оценката отнема приблизително 30-45 минути.",
    msgHomeSection3: "Партньори",
    msgHomeSection2Btn: "Започнете оценката си",
    msgHomeSection3Btn: "КОНТАКТ",

    /** HEADER */
    msgHeader1: "Стратегии за кръгов дизайн и добри практики",
    msgHeader4: "Вход",

    /** DRAWER */
    msgCompany: "КОМПАНИЯ",
    msgDrawer1: "1. Отговорете",
    msgDrawer2: "2. Оценете",
    msgDrawer3: "3. Подобрете",
    msgDrawer4: "Събиране на стратегии",
    msgDrawer6: "Настройки",
    msgDrawer7: "Изход",

    /** LOGIN */
    msgWelcome: "Добре дошли",
    msgWelcomeSubtitle: "Моля, влезте, за да продължите",

    /** REGISTER */
    msgGetStarted: "Започнете",
    msgGetStartedSubtitle: "Този инструмент за самооценка е безплатен и конфиденциален",

    msgFirstname: "Първо име",
    msgLastname: "Фамилия",
    msgEmail: "Имейл",
    msgPassword: "Парола",
    msgConfirmPassword: "Потвърдете паролата",
    msgCompanyUser: "Компания или потребителско име",

    msgLegalRegister: "Прочетох и съм съгласен с <a href='https://ambitcluster.org/en/privacy-policy'>Политиката за поверителност.</a>",
    errorLegalRegister: "Трябва да прочетете и приемете Политиката за поверителност, за да продължите",
    msgLegalRegisterText: "Забележка: Личните данни се събират от AMBIT чрез инструмента FurnCIRCLE единствено за технически и оперативни цели. Отговорите от проучването ще бъдат анализирани в рамките на проекта R-evolve. Никакви лични данни или информация, идентифицираща компанията, няма да бъдат споделени с партньорите на консорциума R-evolve. Всички отговори ще бъдат анализирани на строго анонимна основа. За статистически цели данните могат да бъдат обобщени по държава или сектор на дейност. При никакви обстоятелства резултатите, генерирани от инструмента, няма да бъдат свързани с или използвани за идентифициране на отделна компания.",

    msgNotRegister: "Още не сте се регистрирали? <b>Създайте акаунт тук</b>",
    msgAlreadyRegister: "Вече сте регистрирани? <b>Влезте тук</b>",

    /** HOME TOOL */
    msgClickImage: "Щракнете, за да разширите модела линейно срещу кръговия модел.",

    msgArea: "ОБЛАСТ",
    msgProgress: "ОТГОВОРЕНИ ВЪПРОСИ",

    msgAssessmentAreas: "Стратегии за кръгов дизайн и жизнен цикъл на продукта",
    msgAssessmentDesc: "Стратегиите за кръгов дизайн се прилагат основно по време на фазата на проектиране и разработване на продуктите. Техният (положителен) ефект обаче се проявява в една или повече по-късни фази от жизнения цикъл на продукта, подпомогнати от следпродажбени услуги. Затова един от начините за класифициране на стратегиите за кръгов дизайн е според етапа от жизнения цикъл, върху който въздействат: проектиране, материални ресурси, производство, дистрибуция, фаза на употреба и край на жизнения цикъл.<br/><br/>За разгъване на стратегиите за кръговост е от ключово значение общият подход на компанията към бъдещата Кръгова икономика, както и 'продуктовите аспекти', определени в Чл. 5(1) от Европейския регламент за екодизайн за устойчиви продукти (ESPR), и Дигиталният продуктов паспорт (DPP), въведен чрез ESPR.<br/><br/>ESPR е един от стълбовете в стратегията на ЕС за ресурсно ефективна, нискотоксична и благоприятна за климата Кръгова икономика (CE). Той създава рамка от задължителни условия за пускане на продукти на пазара, изисквайки изпълнение на амбициозни цели за екологични показатели и ресурсна ефективност, за да се остане в границите на планетата. Съгласно 'продуктовите аспекти' в Чл. 5(1), продуктите трябва да бъдат проектирани за дълга употреба, лесен ремонт, повторна употреба и обновяване, както и за безопасно рециклиране (известно и като R-стратегии). Те трябва също да са свободни от проблемни вещества и подходящи за висококачествено оползотворяване на материалите.<br/><br/>DPP, както е въведен чрез ESPR, има за цел да предостави съответната хармонизирана инфраструктура за продуктови данни, която да насърчава прозрачност, проследимост и устойчиви бизнес иновации.<br/><br/>За подробности вижте информационния лист R-evolve | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Моля, отговорете на всички въпроси за всеки блок или фаза от жизнения цикъл, определете вашето ниво на кръгова зрялост и планирайте подобрението и прехода си към по-развита Кръгова икономика.</span>",

    msgAssessment: "Оценка на FurnCIRCLE",
    msgNotApply: "Отбележете всички отговори, които се отнасят до текущото кръгово представяне на вашата компания. Отговорите се запазват автоматично.",
    msgMarkImportant: "Отбележете като важно",
    msgComment: "Коментар",
    msgCommentHolder: "Можете да напишете тук всяка свързана информация или ваши коментари.",

    /** ANSWER */
    msgPerformance: "Оценка на доклада",
    msgPerformanceSubtitle: "Разгледайте индекса на кръговата зрялост на вашата компания и на всяка фаза от жизнения цикъл на продуктите ви.",
    msgCompanyLevel: "Индекс на кръговата зрялост на вашата компания (0%-100%)",
    msgBlockArea: "ФАЗА ОТ ЖИЗНЕНИЯ ЦИКЪЛ",
    msgBlockValues: "СТОЙНОСТИ",

    /** ASSESS */
    msgImprovement: "Доклад за подобрение",
    msgImprovementMainSubtitle: "Научете какво можете да направите, за да подобрите постоянно кръговостта на вашата компания. Знайте стратегиите за дизайн и добрите практики на компаниите, които да помогнат да издигнете компанията си на следващо ниво.</br></br>Фазите от жизнения цикъл и стратегиите за кръгов дизайн с етикет/кръг „червен“ имат ниво на представяне, което е равно на или по-малко от 25% от максималната си стойност и следователно могат да се считат за приоритет за подобрение на кръговостта на компанията. Фазите или стратегиите с етикет/кръг „оранжев“ имат ниво на представяне по-високо от 25% и по-малко от или равно на 75% и затова също е важно да се обърне внимание на тяхното подобрение. Фазите или стратегиите с етикет/кръг „зелен“ имат ниво на представяне по-високо от 75% и следователно са по-малко приоритетни за подобрение.",
    msgImprovementSubtitle: "Научете какво можете да направите, за да подобрите постоянно кръговостта на вашата компания. Знайте стратегиите за дизайн и добрите практики на компаниите, които да помогнат да издигнете компанията си на следващо ниво.",
    msgLifecyclePhases: "Фази на жизнен цикъл",
    msgLifecycleIndex: "Индекс на кръговост на фазата",
    msgActionsToImplement: "Действия за прилагане:",
    msgBaselineScore: "Моят основен резултат",
    msgBusinessCaseEmpty: "Честито! Вече сте приложили основните стратегии, включени в тази категория",

    msgCat1: "ИКОНОМИЧЕСКИ И ОРГАНИЗАЦИОННИ",
    msgCat2: "ОБЩЕСТВЕНИ",
    msgCat3: "ЕКОЛОГИЧНИ",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Прегледайте и разгледайте цялата колекция от стратегии за кръгов дизайн и добри практики на компании от проекта FurnCIRCLE.",
    msgLifecyclePhase: "Фаза от жизнен цикъл",
    msgDifficulty: "Трудност на прилагане",
    msgBusinessDynamics: "Генериране или доставка на стойност",
    msgBusinessFactors: "Стойност на предложението / Разходи / Ползи",

    /** SETTINGS */
    msgUserInfo: "Потребителска информация",
    msgUserCredentials: "Потребителски данни",

    /** MODAL */
    msgAreSure: "Сигурни ли сте?",

    msgSuccess: "Данните са актуализирани успешно",
    msgDeleteSuccess: "Данните са изтрити успешно",

    /** ALT TEXT */
    msgSaveCommentAlt: "Запазете “Коментара.” Не е необходимо да запазвате отговорите на въпросите; те се запазват автоматично.",
    msgDifficultyAlt: "Този етикет показва трудността при прилагането на стратегията за кръгов дизайн.",
    msgBusinessBlockAlt: "Този етикет показва кой бизнес блок от модела CANVAS (Генериране на стойност или Доставка на стойност) е засегнат от прилагането на стратегията за кръгов дизайн.",
    msgImpactBlockAlt: "Този етикет показва кой блок на въздействие от модела CANVAS (Разходи, Ползи или Стойностно предложение) е засегнат от прилагането на стратегията за кръгов дизайн.",

    /** ERROR */
    errorOblData: "Попълнете всички задължителни полета",
    errorEmailFormat: "Грешка в имейл формата",
    errorUserIncorrect: "Невалиден имейл/парола",
    errorSend: "Грешка в комуникацията, моля изчакайте и опитайте отново по-късно",
    errorLength: "Превишен брой символи",
    errorPassSame: "Паролите не съвпадат",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Възстановяване на парола",
    msgRecoveryPasswordSubtitle: "Моля, въведете своя имейл адрес, за да получите код за нулиране на паролата.",
    msgCode: "Код",
    msgNewPassword: "Нова парола",
    actionRequestCode: "ИСКАНЕ НА КОД",
    actionUpdate: "АКТУАЛИЗИРАНЕ",
    actionBack: "НАЗАД",
    msgForgetPassword: "Забравихте ли паролата си?",
    errorRecovery: "Грешка при възстановяване на паролата, моля проверете въведения код",

    /** FOOTER */
    msgFooterContact: "КОНТАКТ",

    msgFooterGr: "Финансирано от Европейския съюз. Мненията и възприятията изразени обаче са само на автора/ите и не отразяват непременно тези на Европейския съюз. Нито Европейският съюз, нито финансиращата институция не могат да бъдат държани отговорни за тях. Референция на споразумение и грант: SOCPL-2022-SOC-DIALOG-01 (Проект 101102389)",
    msgCopyright: "Авторско право&copy;2025 AMBIT. Всички права запазени",

    msgFooterLegal: "Правно уведомление",
    msgFooterPrivacy: "Поверителност",
    msgFooterCookies: "Политика за бисквитки",

    /** PROGRESS VALUES */
    msgProgress0: "Стратегии за кръгов дизайн",

    /** COMPANY SIZES */
    msgCompanySize: "Размер на компанията",
    msgCompanySize1: "По-малко от 10 служители",
    msgCompanySize2: "10-30 служители",
    msgCompanySize3: "30-50 служители",
    msgCompanySize4: "Повече от 50 служители",

    /** PRODUCT TYPES */
    msgProductType: "Тип продукти, които произвеждате",
    msgProductType1: "Мебели за спалня и легла",
    msgProductType2: "Детски / младежки спални",
    msgProductType3: "Системи за сън: матраци и основи",
    msgProductType4: "Мебели за дневна зона",
    msgProductType5: "Столове",
    msgProductType6: "Кухни",
    msgProductType7: "Тапицирани мебели",
    msgProductType8: "Външни мебели",
    msgProductType9: "Мебели в пакет / DIY",
    msgProductType10: "Мебели за здравни и грижовни заведения (болници, домове за грижа и др.)",
    msgProductType11: "Мебели за обществени пространства (летища, църкви, театри и кина), без седалки",
    msgProductType12: "Мебели по поръчка за дома",
    msgProductType13: "Аксесоари - Допълващи елементи",
    msgProductType14: "Аксесоари - Декоративни обекти",
    msgProductType15: "Аксесоари - Текстил",
    msgProductType16: "Търговско обзавеждане (retail / contract interiors)",
    msgProductType17: "Полуфабрикати за мебели",
    msgProductType18: "Други мебели",
    msgProductType19: "Мебели за баня (включително плотове)",
    msgProductType20: "Офис мебели",
    msgProductType21: "Офис преградни стени / стени",
    msgProductType22: "Офис седалки",
    msgProductType23: "Публични седалки / седалки за колективни пространства",
    msgProductType24: "Акустични панели / акустични мебели",
    msgProductType25: "Компоненти за офис мебели",
    msgProductType26: "Други офис мебели / оборудване",
    msgProductType27: "Учебни мебели",

    /* COUNTRIES */
    msgCountry: "Държава",
    msgAfghanistan: "Афганистан",
    msgAlbania: "Албания",
    msgAlgeria: "Алжир",
    msgAmericanSamoa: "Американска Самоа",
    msgAndorra: "Андора",
    msgAngola: "Ангола",
    msgAnguilla: "Ангила",
    msgAntarctica: "Антарктика",
    msgAntiguaandBarbuda: "Антигуа и Барбуда",
    msgArgentina: "Аржентина",
    msgArmenia: "Армения",
    msgAruba: "Аруба",
    msgAustralia: "Австралия",
    msgAustria: "Австрия",
    msgAzerbaijan: "Азербайджан",
    msgBahamas: "Бахамите",
    msgBahrain: "Бахрейн",
    msgBangladesh: "Бангладеш",
    msgBarbados: "Барбадос",
    msgBelarus: "Беларус",
    msgBelgium: "Белгия",
    msgBelize: "Белиз",
    msgBenin: "Бенин",
    msgBermuda: "Бермудски острови",
    msgBhutan: "Бутан",
    msgBolivia: "Боливия",
    msgBosniaHerzegovina: "Босна и Херцеговина",
    msgBotswana: "Ботсуана",
    msgBouvetIsland: "Остров Буве",
    msgBrazil: "Бразилия",
    msgBritishIndian: "Британска Индийска океанска територия",
    msgBrunei: "Бруней",
    msgBulgaria: "България",
    msgBurkinaFaso: "Буркина Фасо",
    msgBurundi: "Бурунди",
    msgCambodia: "Камбоджа",
    msgCameroon: "Камерун",
    msgCanada: "Канада",
    msgCapeVerde: "Кабо Верде",
    msgCaymanIslands: "Кайманови острови",
    msgCentralAfrican: "Централноафриканска република",
    msgChad: "Чад",
    msgChile: "Чили",
    msgChina: "Китай",
    msgChristmasIsland: "Остров Рождество",
    msgCocosIslands: "Острови Кокос (Кийлинг)",
    msgColombia: "Колумбия",
    msgComoros: "Коморски острови",
    msgCongo: "Конго",
    msgRepublicCongo: "Демократична република Конго",
    msgCookIslands: "Острови Кук",
    msgCostaRica: "Коста Рика",
    msgIvoryCoast: "Кот д'Ивоар",
    msgCroatia: "Хърватия",
    msgCuba: "Куба",
    msgCyprus: "Кипър",
    msgCzechRepublic: "Чешка република",
    msgDenmark: "Дания",
    msgDjibouti: "Джибути",
    msgDominica: "Доминика",
    msgDominicanRepublic: "Доминиканска република",
    msgEastTimor: "Източен Тимор",
    msgEcuador: "Еквадор",
    msgEgypt: "Египет",
    msgEngland: "Англия",
    msgElSalvador: "Ел Салвадор",
    msgEquatorialGuinea: "Екваториална Гвинея",
    msgEritrea: "Еритрея",
    msgEstonia: "Естония",
    msgEthiopia: "Етиопия",
    msgFalklandIslands: "Фолкландски острови",
    msgFaroeIslands: "Фарьорски острови",
    msgFijiIslands: "Фиджи",
    msgFinland: "Финландия",
    msgFrance: "Франция",
    msgFrenchGuiana: "Френска Гвиана",
    msgFrenchPolynesia: "Френска Полинезия",
    msgFrenchSouthern: "Френски Южни територии",
    msgGabon: "Габон",
    msgGambia: "Гамбия",
    msgGeorgia: "Грузия",
    msgGermany: "Германия",
    msgGhana: "Гана",
    msgGibraltar: "Гибралтар",
    msgGreece: "Гърция",
    msgGreenland: "Грьонландия",
    msgGrenada: "Гренада",
    msgGuadeloupe: "Гваделупа",
    msgGuam: "Гуам",
    msgGuatemala: "Гватемала",
    msgGuernsey: "Гърнси",
    msgGuinea: "Гвинея",
    msgGuineaBissau: "Гвинея-Бисау",
    msgGuyana: "Гаяна",
    msgHaiti: "Хаити",
    msgHeardMcDonald: "Остров Хърд и островите Макдоналд",
    msgHolySee: "Свещената столница (Ватикан)",
    msgHonduras: "Хондурас",
    msgHongKong: "Хонг Конг",
    msgHungary: "Унгария",
    msgIceland: "Исландия",
    msgIndia: "Индия",
    msgIndonesia: "Индонезия",
    msgIran: "Иран",
    msgIraq: "Ирак",
    msgIreland: "Ирландия",
    msgIsrael: "Израел",
    msgIsleMan: "Остров Ман",
    msgItaly: "Италия",
    msgJamaica: "Ямайка",
    msgJapan: "Япония",
    msgJersey: "Джърси",
    msgJordan: "Йордания",
    msgKazakhstan: "Казахстан",
    msgKenya: "Кения",
    msgKiribati: "Кирибати",
    msgKuwait: "Кувейт",
    msgKyrgyzstan: "Киргизстан",
    msgLaos: "Лаос",
    msgLatvia: "Латвия",
    msgLebanon: "Ливан",
    msgLesotho: "Лесото",
    msgLiberia: "Либерия",
    msgLibyanJamahiriya: "Либийска арабска джамахирия",
    msgLiechtenstein: "Лихтенщайн",
    msgLithuania: "Литва",
    msgLuxembourg: "Люксембург",
    msgMacao: "Макао",
    msgNorthMacedonia: "Северна Македония",
    msgMadagascar: "Мадагаскар",
    msgMalawi: "Малави",
    msgMalaysia: "Малайзия",
    msgMaldives: "Малдиви",
    msgMali: "Мали",
    msgMalta: "Малта",
    msgMarshallIslands: "Маршалови острови",
    msgMartinique: "Мартиника",
    msgMauritania: "Мавритания",
    msgMauritius: "Мавриций",
    msgMayotte: "Майот",
    msgMexico: "Мексико",
    msgMicronesia: "Микронезия, Федеративни щати на",
    msgMoldova: "Молдова",
    msgMonaco: "Монако",
    msgMongolia: "Монголия",
    msgMontserrat: "Монсерат",
    msgMontenegro: "Черна гора",
    msgMorocco: "Мароко",
    msgMozambique: "Мозамбик",
    msgMyanmar: "Мианмар",
    msgNamibia: "Намибия",
    msgNauru: "Науру",
    msgNepal: "Непал",
    msgNetherlands: "Нидерландия",
    msgNetherlandsAntilles: "Нидерландски Антили",
    msgNewCaledonia: "Нова Каледония",
    msgNewZealand: "Нова Зеландия",
    msgNicaragua: "Никарагуа",
    msgNiger: "Нигер",
    msgNigeria: "Нигерия",
    msgNiue: "Ниуе",
    msgNorfolkIsland: "Остров Норфолк",
    msgNorthKorea: "Северна Корея",
    msgNorthernIreland: "Северна Ирландия",
    msgNorthernMariana: "Северни Мариански острови",
    msgNorway: "Норвегия",
    msgOman: "Оман",
    msgPakistan: "Пакистан",
    msgPalau: "Палау",
    msgPalestine: "Палестина",
    msgPanama: "Панама",
    msgPapua: "Папуа Нова Гвинея",
    msgParaguay: "Парагвай",
    msgPeru: "Перу",
    msgPhilippines: "Филипини",
    msgPitcairn: "Питкерн",
    msgPoland: "Полша",
    msgPortugal: "Португалия",
    msgPuertoRico: "Пуерто Рико",
    msgQatar: "Катар",
    msgReunion: "Реюнион",
    msgRomania: "Румъния",
    msgRussianFederation: "Русия",
    msgRwanda: "Руанда",
    msgSaintHelena: "Света Елена",
    msgSaintKitts: "Сейнт Китс и Невис",
    msgSaintLucia: "Сейнт Лусия",
    msgSaintPierre: "Сейнт Пиер и Микелон",
    msgSaintVincent: "Сейнт Винсент и Гренадините",
    msgSamoa: "Самоа",
    msgSanMarino: "Сан Марино",
    msgSaoTome: "Сао Томе и Принсипе",
    msgSaudiArabia: "Саудитска Арабия",
    msgScotland: "Шотландия",
    msgSenegal: "Сенегал",
    msgSerbia: "Сърбия",
    msgSeychelles: "Сейшелски острови",
    msgSierraLeone: "Сиера Леоне",
    msgSingapore: "Сингапур",
    msgSlovakia: "Словакия",
    msgSlovenia: "Словения",
    msgSolomonIslands: "Соломонови острови",
    msgSomalia: "Сомалия",
    msgSouthAfrica: "Южна Африка",
    msgSouthSandwich: "Южна Джорджия и Южни Сандвичови острови",
    msgSouthKorea: "Южна Корея",
    msgSouthSudan: "Южен Судан",
    msgSpain: "Испания",
    msgSriLanka: "Шри Ланка",
    msgSudan: "Судан",
    msgSuriname: "Суринам",
    msgSvalbardJan: "Свальбард и Ян Майен",
    msgSwaziland: "Свазиленд",
    msgSweden: "Швеция",
    msgSwitzerland: "Швейцария",
    msgSyria: "Сирия",
    msgTajikistan: "Таджикистан",
    msgTanzania: "Танзания",
    msgThailand: "Тайланд",
    msgTimorLeste: "Източен Тимор",
    msgTogo: "Того",
    msgTokelau: "Токелау",
    msgTonga: "Тонга",
    msgTrinidadTobago: "Тринидад и Тобаго",
    msgTunisia: "Тунис",
    msgTurkey: "Турция",
    msgTurkmenistan: "Туркменистан",
    msgTurksCaicos: "Търкс и Кайкос",
    msgTuvalu: "Тувалу",
    msgUganda: "Уганда",
    msgUkraine: "Украйна",
    msgUnitedArabEmirates: "Обединени арабски емирства",
    msgUnitedKingdom: "Обединеното кралство",
    msgUnitedStates: "Съединените щати",
    msgUnitedStatesMinor: "Населени американски острови",
    msgUruguay: "Уругвай",
    msgUzbekistan: "Узбекистан",
    msgVanuatu: "Вануату",
    msgVenezuela: "Венецуела",
    msgVietnam: "Виетнам",
    msgVirginIslandsBritish: "Британски Вирджински острови",
    msgVirginIslandsUS: "Вирджински острови, САЩ",
    msgWales: "Уелс",
    msgWallisFutuna: "Уолис и Футуна",
    msgWesternSahara: "Западна Сахара",
    msgYemen: "Йемен",
    msgZambia: "Замбия",
    msgZimbabwe: "Зимбабве"
}

export default bg;